import React, { useEffect, useCallback } from 'react';
import { X, ArrowLeft, ArrowRight } from '@phosphor-icons/react';

const Lightbox = ({ src, alt, onClose, onPrev, onNext }) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
    if (e.key === 'ArrowLeft' && onPrev) onPrev();
    if (e.key === 'ArrowRight' && onNext) onNext();
  }, [onClose, onPrev, onNext]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [handleKeyDown]);

  if (!src) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center"
      data-testid="lightbox-overlay"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/90 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-10 p-2 bg-white/10 hover:bg-white/20 transition-colors rounded-full"
        data-testid="lightbox-close"
      >
        <X size={24} className="text-white" />
      </button>

      {/* Navigation arrows */}
      {onPrev && (
        <button
          onClick={(e) => { e.stopPropagation(); onPrev(); }}
          className="absolute left-4 z-10 p-3 bg-white/10 hover:bg-white/20 transition-colors rounded-full"
          data-testid="lightbox-prev"
        >
          <ArrowLeft size={24} className="text-white" />
        </button>
      )}
      {onNext && (
        <button
          onClick={(e) => { e.stopPropagation(); onNext(); }}
          className="absolute right-4 z-10 p-3 bg-white/10 hover:bg-white/20 transition-colors rounded-full"
          data-testid="lightbox-next"
        >
          <ArrowRight size={24} className="text-white" />
        </button>
      )}

      {/* Image */}
      <img
        src={src}
        alt={alt || 'Full size image'}
        className="relative z-[1] max-w-[90vw] max-h-[90vh] object-contain rounded select-none animate-in fade-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
        data-testid="lightbox-image"
      />

      {/* Caption */}
      {alt && (
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 px-4 py-2 bg-black/60 rounded text-white text-sm max-w-md text-center truncate">
          {alt}
        </div>
      )}
    </div>
  );
};

export default Lightbox;
